import React from 'react';
import { makeStyles } from "@material-ui/core";

export default function SelectedRecyclingWorkstation(props) {
    const classes = useStyles();

    return <React.Fragment>
        <div className={classes.selectedLineContainer}>
            <p className={classes.selectedLine}>
                {props.line}
            </p>
        </div>
    </React.Fragment >
}

const useStyles = makeStyles({
    selectedLineContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: "none",
        border: "1px solid #4654FB",
        borderRadius: "3px",
        width: "80px",
        height: "28px",
    },

    selectedLine: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "#4654FB",
        margin: "0",
    }
});